var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-data-editor',{attrs:{"id":_vm.id,"title":"Редактирование тарифа","resource":"tariffs","elements":_vm.elements,"add-message":"Тариф добавлен","edit-message":"Тариф изменен"},on:{"change":(payload) => _vm.isChanged = payload}})
}
var staticRenderFns = []

export { render, staticRenderFns }